/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterArticlePastSearchPaidBody
 */
export interface RegisterArticlePastSearchPaidBody {
    /**
     * 自動更新あり/なし
     * @type {boolean}
     * @memberof RegisterArticlePastSearchPaidBody
     */
    isAutoRenewed: boolean;
}

export function RegisterArticlePastSearchPaidBodyFromJSON(json: any): RegisterArticlePastSearchPaidBody {
    return RegisterArticlePastSearchPaidBodyFromJSONTyped(json, false);
}

export function RegisterArticlePastSearchPaidBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterArticlePastSearchPaidBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAutoRenewed': json['is_auto_renewed'],
    };
}

export function RegisterArticlePastSearchPaidBodyToJSON(value?: RegisterArticlePastSearchPaidBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_auto_renewed': value.isAutoRenewed,
    };
}

